import React, { useState } from 'react';
import { FaBolt, FaFeather, FaSync, FaGlobeAmericas, FaLayerGroup, FaExclamationTriangle, FaDesktop, FaPlay, FaShieldAlt, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { SiGoogle, SiOpenai, SiClaude, SiTelegram, SiWhatsapp, SiDiscord, SiAnydesk, SiTeamviewer } from 'react-icons/si';
import StaticParticles from '../StaticParticles/StaticParticles';
import './Module3Card.css';

const Module3Card = ({ 
  onClick,
  particlesCount = 400,
  particlesOpacity = 0.6,
  particlesSway = 0.55
}) => {
  return (
    <div className="module3-card" onClick={onClick}>

      {/* Частицы — один слой */}
      <StaticParticles 
        count={particlesCount}
        color="#FDB241"
        opacity={particlesOpacity}
        sway={particlesSway}
      />

      {/* Ember overlay — CSS gradient, без второго canvas */}
      <div className="ember-overlay"></div>

      {/* Крутящийся border — conic beam */}
      <div className="spinning-border"></div>
      {/* Статичная рамка под ним */}
      <div className="golden-border"></div>

      {/* EXCLUSIVE badge */}
      <div className="exclusive-badge">
        <span className="badge-diamond">💎</span>
        <span className="badge-text">EXCLUSIVE</span>
      </div>

      {/* Контент */}
      <div className="card-content">
        
        <div className="top-section">
          <div className="text-section">
            <div className="module-label"></div>
            <h2 className="main-title">
              Server <span className="golden-text">Streaming</span>
            </h2>
            <p className="description">
              ☁️ Cloud Server • Browser Only • Video Loop
            </p>
          </div>
          
          <div className="server-section">
            <div className="server-wrapper">
              <div className="golden-trail trail-1"></div>
              <div className="golden-trail trail-2"></div>
              <div className="golden-trail trail-3"></div>
              <img 
                src={`${process.env.PUBLIC_URL}/images/server.webp`}
                alt="Cloud Server" 
                className="server-img"
              />
            </div>
          </div>
        </div>

        <div className="stats-row">
          <div className="stat-box">
            <div className="stat-label">Setup Time</div>
            <div className="stat-value">Instant</div>
          </div>
          <div className="stat-box">
            <div className="stat-label">File Size</div>
            <div className="stat-value">0 MB</div>
          </div>
        </div>
        
        <div className="benefits-row">
          <div className="benefit-box">
            <div className="benefit-icon-circle">
              <FaBolt className="benefit-icon-svg" />
            </div>
            <div className="benefit-text">
              <h4 className="benefit-title">Instant Start</h4>
              <p className="benefit-desc">Just connect browser</p>
            </div>
          </div>
          
          <div className="benefit-box">
            <div className="benefit-icon-circle">
              <FaFeather className="benefit-icon-svg" />
            </div>
            <div className="benefit-text">
              <h4 className="benefit-title">Ultra Light</h4>
              <p className="benefit-desc">0 MB - nothing to install</p>
            </div>
          </div>

          <div className="benefit-box">
            <div className="benefit-icon-circle">
              <FaSync className="benefit-icon-svg" />
            </div>
            <div className="benefit-text">
              <h4 className="benefit-title">Video Loop</h4>
              <p className="benefit-desc">Walk away anytime</p>
            </div>
          </div>

          <div className="benefit-box">
            <div className="benefit-icon-circle">
              <FaGlobeAmericas className="benefit-icon-svg" />
            </div>
            <div className="benefit-text">
              <h4 className="benefit-title">Any Location</h4>
              <p className="benefit-desc">Take exam from anywhere</p>
            </div>
          </div>
        </div>
        
        {/* Apps */}
        <div className="apps-section">
          <div className="apps-header">
            <FaLayerGroup className="apps-icon" />
            <span className="apps-label">Total Freedom + AFK:</span>
          </div>
          <div className="apps-badges">
            <div className="app-badge"><SiGoogle className="badge-icon badge-icon-color" /> Google</div>
            <div className="app-badge"><SiOpenai className="badge-icon badge-icon-color" /> ChatGPT</div>
            <div className="app-badge"><SiClaude className="badge-icon badge-icon-color" /> Claude</div>
            <div className="app-badge"><SiTelegram className="badge-icon badge-icon-color" /> TG</div>
            <div className="app-badge"><SiWhatsapp className="badge-icon badge-icon-color" /> WhatsApp</div>
            <div className="app-badge"><SiDiscord className="badge-icon badge-icon-color" /> Discord</div>
            <div className="app-badge highlight">🚶 Walk away AFK</div>
            <div className="app-badge highlight">🎯 Any applications</div>
          </div>
        </div>

        {/* Remote Control */}
        <div className="remote-section">
          <div className="remote-header">
            <FaDesktop className="remote-icon" />
            <span className="remote-label">+ Remote Control Help:</span>
          </div>
          <div className="remote-badges">
            <div className="remote-badge"><SiAnydesk className="badge-icon badge-icon-color" /> AnyDesk</div>
            <div className="remote-badge"><SiTeamviewer className="badge-icon badge-icon-color" /> TeamViewer</div>
          </div>
        </div>

        {/* AFK Video Loop */}
        <div className="afk-section">
          <div className="afk-header">
            <FaPlay className="afk-icon" />
            <span className="afk-label">+ AFK Video Loop:</span>
          </div>
          <p className="afk-desc">
            Automated video loop — walk away for as long as you need, system runs on its own
          </p>
          <div className="afk-badges">
            <div className="afk-badge">🎬 Pre-recorded loop</div>
            <div className="afk-badge">⏱️ Infinite repeat</div>
            <div className="afk-badge">🔇 Background mode</div>
          </div>
        </div>

        {/* Physical Server Bypass */}
        <div className="proxy-section">
          <div className="proxy-header">
            <FaShieldAlt className="proxy-icon" />
            <span className="proxy-label">+ Physical Server Bypass:</span>
          </div>
          <p className="proxy-desc">
            Full physical PC on our side — all proctors bypass guaranteed. Unique custom-built camera relay module streams your feed to the proctor seamlessly and without any traces.
          </p>
          <div className="proxy-badges">
            <div className="proxy-badge">🛡️ All Proctors Bypass</div>
            <div className="proxy-badge">💻 Full Physical PC</div>
            <div className="proxy-badge proxy-badge-cam">📷 Custom Camera Relay Module</div>
          </div>
        </div>

        {/* Warning */}
        <div className="warning-section">
          <div className="warning-icon">
            <FaExclamationTriangle />
          </div>
          <p className="warning-text">
            Requires stable internet connection • Depends on server availability
          </p>
        </div>
        
        <button className="details-button">
          View Full Technical Details →
        </button>
      </div>
    </div>
  );
};

export default Module3Card;
